<template>
<div class='container'>
  <div class='bg' v-if='show' @click='show=false'></div>
  <div class='mainmenu' :class="{mainmenuopen: show}">
    <div class='name'>{{name}}</div>
    <div class='cover'>
      <select :value="$store.state.context[name + '_id']" @input="$store.commit('setMenuChoice', {which: name, value: parseInt($event.target.value)})">
	<option v-if="parent===null || option[parent+'_id'] == parent_id" v-for='option in $store.state.data[select]' :value='option.id'>{{option.name}} </option>
      </select>
    </div>
    <img @click='show=!show' class='carrot' src="../assets/icons/down.svg">
  </div>
  <!--{{select}} {{parent}
  <ul>
    <li v-for="option in $store.state.data[select]">{{option}}</li>
  </ul>-->
  <transition name='slide-down'>
    <div class='menubody' v-if='show'>
      <p v-for='item in $store.state.data.menus[name]' @click="show=false">
        <router-link :to="$store.getters.menu_url(item)" v-if="$store.getters.menu_check_perm(item.perms)">{{item.name}}</router-link>
      </p>
    </div>
  </transition>
</div>
</template>

<script>

export default {
    props: ['name', 'cover', 'select', 'parent', 'parent_id', 'watch' ],
    data: function() {return {
        show: false
    }},
    watch: {
        watch: function(new_val, old_val) {
            this.$store.commit('setMenuChoiceFirst', this.name)
        }
    }
    
}

  
</script>

<style scoped>
.container {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
}
.mainmenu{
    border: 2px solid #666;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: flex-end;
    position: relative;
    background-color: white;
    height: 45px;
    margin-right: 10px;
    margin-top: 5px;
    overflow: hidden;
}
.mainmenuopen{
    border-bottom: 0;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
    box-shadow: 0 5px 5px rgba(0,0,0,0.5);
}
.name {
    position: absolute;
    top:2px;
    left: 2px;
    font-size: 0.9em;
    color: #666;
    text-transform: capitalize;
}
.cover {
    padding-left: 16px;
}
.carrot {
    position: absolute;
    width: 16px;
    right: 10px;
    top: 15px;
}
.bg {
    position: absolute;
    background-color: rgba(0,0,0,0.25);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
.menubody {
    background-color: white;
    position: absolute;
    margin-right: 10px;
    overflow: hidden;
    z-index: 1;
    width: calc(33.333% - 46px);
    border-radius: 4px;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    border: 2px solid #666;
    border-top: 0;
    padding: 20px;
    box-shadow: 0 5px 5px rgba(0,0,0,0.5);
}
.slide-down-enter-active {
  animation: slide-down-in 0.1s;
}
.slide-down-leave-active {
  animation: slide-down-in 0.1s reverse;
}
@keyframes slide-down-in {
    0% {
        transform: translate(0, -50%);
        height: 0;
    }
    100% {
        transform: translate(0, 0%);
    }
}
@media screen and (max-width: 700px) {
    .container {
        width: 100%;
        flex-basis: unset;
    }
    .menubody {
        width: 80%;
    }
}
a {
    color: #222;
    text-decoration: none;
}
</style>
